import { Box, Tooltip, Typography } from "@mui/material";

export interface InputLabelProps {
  label?: string;
  required?: boolean;
  endAdornment?: React.ReactNode;
  tooltip?: string;
  htmlFor?: string;
  disabled?: boolean;
}

export const BlInputLabel = ({
  label,
  required,
  endAdornment,
  tooltip,
  htmlFor,
  disabled,
}: InputLabelProps): React.ReactNode => {
  const content = (
    <Box
      component="label"
      htmlFor={htmlFor}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        mb: 2,
        color: disabled ? "text.disabled" : "text.secondary",
        cursor: htmlFor ? "default" : undefined,
      }}
    >
      <Typography variant="body2" component="span" lineHeight={1}>
        {label}
      </Typography>
      {required && (
        <Box
          component="span"
          sx={{
            color: "error.main",
            fontSize: 12,
            fontWeight: 400,
            lineHeight: 1,
          }}
        >
          *
        </Box>
      )}
      {endAdornment}
    </Box>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{content as React.ReactElement}</Tooltip>;
  }

  return content;
};
